import { render, staticRenderFns } from "./eventComp_mode_18.vue?vue&type=template&id=68f2c0d7&scoped=true"
import script from "./eventComp_mode_18.vue?vue&type=script&lang=js"
export * from "./eventComp_mode_18.vue?vue&type=script&lang=js"
import style0 from "./eventComp_mode_18.vue?vue&type=style&index=0&id=68f2c0d7&prod&lang=scss&scoped=true"
import style1 from "./eventComp_mode_18.vue?vue&type=style&index=1&id=68f2c0d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f2c0d7",
  null
  
)

export default component.exports